import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertSku from "../../../components/skuComponent/insertSku";
import InsertSkuType from "./InsertSkuType";
import { translate } from "react-i18next";
import {TITLES} from './skuTypeConstants'
import ReadAxios from "../../../components/axiosComponent/read";

class AddSku extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }

    if(this.props?.location?.state?.serviceCategoryId){
      this.getIsolationCategoryMapping(this.props?.location?.state?.serviceCategoryId)
    }
  }

  getIsolationCategoryMapping = (serviceCategoryId)=>{
    ReadAxios({
      url : 'serviceCategoryIsolationMapping',
      readItems : { serviceCategoryId }
    }).then((res)=>{
      if(res.data?.resultSet?.length){
        let isolationCategoryIds = res?.data?.resultSet.map((data)=> data.isolationCategoryId)
        this.setState({editData : {...this.state.editData , isolationCategoryIds}})
      }
    })
  }

  onFormSubmit = () => {
    this.props.history.push("/productType");
    this.props.history.go();
  };
  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.state.title === 'add_title' ? (TITLES.add_title||'Add Product Category') : (TITLES.edit_title||'Edit Product Category')} LinkName="/productType" />
        <div className="m-2">
          <InsertSkuType
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("sku")(AddSku);
